import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import SnackBar from '../SnackBar';

const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
        padding: 0,
    },
}));
const ResetProgress = (props) => {
    const { className, handleResetProgress, open, itemId, service, pageLink, initializeData, resetProgress_method, rowsPerPage, ...rest } = props;
    const classes = useStyles();
    const [openAlert, setOpenAlert] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [severity, setAlertSeverity] = React.useState('success');
    const handleClose = () => {
        setOpenAlert(false);
    };

    const resetProgress = () => {
        if (service !== null) {
            service.resetProgress_method(`progress/${itemId}/reset`).then((data) => {
                if (!data?.statusCode == 10000) {
                    setOpenAlert(true);
                    let errorMessage = data?.message ? data.message : 'Technical error! Contact the Developers Team';
                    setAlertSeverity('warning')
                    setMessage(errorMessage)
                } else {
                    setOpenAlert(true);
                    setMessage('Progress reseted successfuly')
                    handleResetProgress();
                    initializeData(rowsPerPage);
                }
            });
        }
    };
    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Dialog
                open={open}
                onClose={handleResetProgress}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Reset Progress</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure to reset Progress?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleResetProgress} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={resetProgress} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <SnackBar
                open={openAlert}
                handleClose={handleClose}
                message={message}
                severity={severity}
            />
        </div>
    );
};

ResetProgress.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool,
    handleResetProgress: PropTypes.func,
    itemId: PropTypes.number,
};

export default ResetProgress;
